module.exports = __webpack_public_path__ + "assets/img/zh1.fc3556a4.png";